import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showMessage } from "./common.slice";
import { getSessionData } from "utils/common";

const initialState = {
  commissionList: [],
  commissionLoading: false,
  commissionUpdated: false,
  rebateBalance: 0,
  rebateEntries: [],
};

export const getCommissionByUser = createAsyncThunk(
  "commission/get-by-user",
  (userId, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`commission/settings/get-by-user/${userId}`)
        .then(({ data }) => {
          if (data.status === 200) resolve(data.data || []);
          else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          dispatch(
            showMessage({ message: error?.response?.data?.message || error.message })
          );
          reject(error);
        });
    });
  }
);

export const saveCommissionSetting = createAsyncThunk(
  "commission/save",
  (payload, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { userId } = getSessionData();
      axios
        .post("commission/settings/save", { ...payload, createdBy: userId })
        .then(({ data }) => {
          if (data.status === 200) {
            dispatch(showMessage({ message: data.message, varient: "success" }));
            resolve(data);
          } else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          dispatch(
            showMessage({ message: error?.response?.data?.message || error.message })
          );
          reject(error);
        });
    });
  }
);

export const deleteCommissionSetting = createAsyncThunk(
  "commission/delete",
  (id, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { userId } = getSessionData();
      axios
        .post(`commission/settings/delete/${id}?deletedBy=${userId}`)
        .then(({ data }) => {
          if (data.status === 200) {
            dispatch(showMessage({ message: data.message, varient: "success" }));
            resolve(data);
          } else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          dispatch(
            showMessage({ message: error?.response?.data?.message || error.message })
          );
          reject(error);
        });
    });
  }
);

export const getRebateBalance = createAsyncThunk(
  "commission/rebate-balance",
  (userId, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`commission/rebate/get-balance/${userId}`)
        .then(({ data }) => {
          if (data.status === 200) resolve(data.data);
          else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          dispatch(
            showMessage({ message: error?.response?.data?.message || error.message })
          );
          reject(error);
        });
    });
  }
);

export const getRebateEntries = createAsyncThunk(
  "commission/rebate-entries",
  ({ userId, pageNo = 1, pageSize = 50 }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`commission/rebate/get-entries/${userId}/${pageNo}/${pageSize}`)
        .then(({ data }) => {
          if (data.status === 200) resolve(data.data || []);
          else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          dispatch(
            showMessage({ message: error?.response?.data?.message || error.message })
          );
          reject(error);
        });
    });
  }
);

export const transferRebateToBalance = createAsyncThunk(
  "commission/rebate-transfer",
  (payload, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { userId } = getSessionData();
      axios
        .post("commission/rebate/transfer-to-balance", { ...payload, createdBy: userId })
        .then(({ data }) => {
          if (data.status === 200) {
            dispatch(showMessage({ message: data.message, varient: "success" }));
            resolve(data);
          } else {
            dispatch(showMessage({ message: data.message }));
            reject(data);
          }
        })
        .catch((error) => {
          dispatch(
            showMessage({ message: error?.response?.data?.message || error.message })
          );
          reject(error);
        });
    });
  }
);

const commission = createSlice({
  name: "commission",
  initialState,
  reducers: {
    setCommissionUpdated: (state, action) => {
      state.commissionUpdated = action.payload ?? false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommissionByUser.pending, (state) => {
        state.commissionLoading = true;
      })
      .addCase(getCommissionByUser.fulfilled, (state, action) => {
        state.commissionList = action.payload || [];
        state.commissionLoading = false;
      })
      .addCase(getCommissionByUser.rejected, (state) => {
        state.commissionLoading = false;
      })
      .addCase(saveCommissionSetting.fulfilled, (state) => {
        state.commissionUpdated = true;
      })
      .addCase(deleteCommissionSetting.fulfilled, (state) => {
        state.commissionUpdated = true;
      })
      .addCase(getRebateBalance.fulfilled, (state, action) => {
        state.rebateBalance = action.payload?.balance ?? 0;
      })
      .addCase(getRebateEntries.fulfilled, (state, action) => {
        state.rebateEntries = action.payload || [];
      })
      .addCase(transferRebateToBalance.fulfilled, (state) => {
        state.commissionUpdated = true;
      });
  },
});

export const { setCommissionUpdated } = commission.actions;
export default commission.reducer;
